import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Check, Trash2 } from 'lucide-react';
import { displayDate } from '../../lib/dates';

const badgeClass = (isDeducted) => isDeducted
  ? 'bg-[#2E4632]/10 text-[#2E4632] border border-[#2E4632]/20'
  : 'bg-[#D97706]/10 text-[#D97706] border border-[#D97706]/20';

export const AdvanceCardList = ({ advances, fmt, onMarkDeducted, onDelete }) => (
  <div className="md:hidden space-y-3" data-testid="advances-mobile-list">
    {advances.length === 0 ? (
      <Card className="bg-white border border-[#D1D1CD] rounded-lg">
        <CardContent className="p-6 text-center text-[#5C5C5C]">
          No advance payments found
        </CardContent>
      </Card>
    ) : (
      advances.map((advance) => (
        <Card
          key={advance.id}
          data-testid={`advance-card-${advance.id}`}
          className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm"
        >
          <CardContent className="p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-[#1C1C1E] truncate">{advance.worker_name}</p>
                <p className="text-xs text-[#5C5C5C] mt-0.5">
                  {displayDate(advance.date || advance.created_at)}
                </p>
              </div>
              <Badge className={badgeClass(advance.is_deducted)}>
                {advance.is_deducted ? 'Deducted' : 'Pending'}
              </Badge>
            </div>
            <p className="mt-2 text-2xl font-bold text-[#D97706]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {fmt(advance.amount)}
            </p>
            {advance.reason && (
              <p className="mt-1.5 text-sm text-[#5C5C5C] line-clamp-2">{advance.reason}</p>
            )}
            <div className="mt-3 pt-3 border-t border-[#D1D1CD]/60 flex justify-end gap-2">
              {!advance.is_deducted && (
                <Button
                  variant="ghost"
                  size="sm"
                  data-testid={`mark-deducted-mobile-${advance.id}`}
                  onClick={() => onMarkDeducted(advance.id)}
                  className="h-9 text-[#2E4632] hover:bg-[#2E4632]/10"
                >
                  <Check className="w-4 h-4 mr-1.5" /> Mark deducted
                </Button>
              )}
              <Button
                variant="ghost"
                size="sm"
                data-testid={`delete-advance-mobile-${advance.id}`}
                onClick={() => onDelete(advance.id)}
                className="h-9 text-[#BC4749] hover:bg-[#BC4749]/10"
              >
                <Trash2 className="w-4 h-4 mr-1.5" /> Delete
              </Button>
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
);
